import { Result, failure, success } from '../shared'
import { EventProvider } from './event.provider'
import {
  BeforeClientAddEditParams,
  BeforeLoanAddParams,
  BeforeLoanAddServerData,
  BeforeLoanDisburseParams,
  BeforeLoanDisburseServerData,
  BeforeEntryAddEditParams,
  BeforeEntryAddEditServerData,
  BeforeConvAddEditParams,
  BeforeConvAddEditServerData,
  BeforeLoanCoverParams,
  BeforeLoanCoverServerData,
  BeforeLoanVisaParams,
  BeforeLoanVisaServerData,
  BeforeCollateralAddEditParams,
  BeforeCollateralAddEditServerData,
  BeforeUccPayParams,
  BeforeUccPayServerData,
  EventsViewParams,
  EventsViewServerData,
  EventFailure,
  EventServiceErrorCode,
} from './event.types'

export class EventService {
  constructor(private eventProvider: EventProvider) {}

  public async beforeClientAddEdit(params: BeforeClientAddEditParams): Promise<Result<void, EventFailure>> {
    try {
      const { data } = await this.eventProvider.beforeClientAddEdit(params)
      return success(data)
    } catch (error) {
      return failure(EventServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async beforeLoanAdd(params: BeforeLoanAddParams): Promise<Result<BeforeLoanAddServerData, EventFailure>> {
    try {
      const { data } = await this.eventProvider.beforeLoanAdd(params)
      return success(data)
    } catch (error) {
      return failure(EventServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async beforeLoanDisburse(
    params: BeforeLoanDisburseParams,
  ): Promise<Result<BeforeLoanDisburseServerData, EventFailure>> {
    try {
      const { data } = await this.eventProvider.beforeLoanDisburse(params)
      return success(data)
    } catch (error) {
      return failure(EventServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async beforeEntryAddEdit(
    params: BeforeEntryAddEditParams,
  ): Promise<Result<BeforeEntryAddEditServerData, EventFailure>> {
    try {
      const { data } = await this.eventProvider.beforeEntryAddEdit(params)
      return success(data)
    } catch (error) {
      return failure(EventServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async beforeConvAddEdit(
    params: BeforeConvAddEditParams,
  ): Promise<Result<BeforeConvAddEditServerData, EventFailure>> {
    try {
      const { data } = await this.eventProvider.beforeConvAddEdit(params)
      return success(data)
    } catch (error) {
      return failure(EventServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async beforeLoanCover(
    params: BeforeLoanCoverParams,
  ): Promise<Result<BeforeLoanCoverServerData, EventFailure>> {
    try {
      const { data } = await this.eventProvider.beforeLoanCover(params)
      return success(data)
    } catch (error) {
      return failure(EventServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async beforeLoanVisa(params: BeforeLoanVisaParams): Promise<Result<BeforeLoanVisaServerData, EventFailure>> {
    try {
      const { data } = await this.eventProvider.beforeLoanVisa(params)
      return success(data)
    } catch (error) {
      return failure(EventServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async beforeCollateralAddEdit(
    params: BeforeCollateralAddEditParams,
  ): Promise<Result<BeforeCollateralAddEditServerData, EventFailure>> {
    try {
      const { data } = await this.eventProvider.beforeCollateralAddEdit(params)
      return success(data)
    } catch (error) {
      return failure(EventServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async beforeUccPay(params: BeforeUccPayParams): Promise<Result<BeforeUccPayServerData, EventFailure>> {
    try {
      const { data } = await this.eventProvider.beforeUccPay(params)
      return success(data)
    } catch (error) {
      return failure(EventServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async view(params: EventsViewParams): Promise<Result<EventsViewServerData, EventFailure>> {
    try {
      const { data } = await this.eventProvider.view(params)
      return success(data)
    } catch (error) {
      return failure(EventServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
}
